interface Pillar {
  icon: string;
  title: string;
  desc: string;
  bullets: string[];
}

const PILLARS: Pillar[] = [
  {
    icon: "🎥",
    title: "Lekcje na żywo z lektorem",
    desc: "Wbudowany videoroom — bez Zooma, bez instalacji. Certyfikowani lektorzy, harmonogram, materiały i nagrania.",
    bullets: ["HD video + audio", "Wspólna tablica i czat", "Nagranie każdej lekcji"],
  },
  {
    icon: "🤖",
    title: "AI Awatar 24/7",
    desc: "Arthur rozmawia z Tobą jak człowiek. Ćwiczysz wymowę, słownictwo i płynność wtedy, kiedy masz czas.",
    bullets: ["Naturalny głos i mimika", "Korekta w czasie rzeczywistym", "Tematy dopasowane do poziomu"],
  },
  {
    icon: "📊",
    title: "Inteligentny scoring",
    desc: "Każda sesja automatycznie oceniana: płynność, wymowa, gramatyka, słownictwo. Widzisz dokładnie co poprawiać.",
    bullets: ["Raport po każdej sesji", "Trendy postępu", "Sugestie dla lektora"],
  },
];

export function Pillars(): JSX.Element {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <div className="text-xs text-lime-500 uppercase tracking-widest font-semibold mb-3">Trzy filary</div>
          <h2 className="text-3xl md:text-5xl font-bold text-white tracking-tight">
            Wszystko, czego potrzebujesz, żeby <span className="text-lime-500">zacząć mówić</span>
          </h2>
          <p className="mt-4 text-ink-300 text-lg">
            Łączymy to, co najlepsze z trzech światów — i robimy to w jednej aplikacji.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {PILLARS.map((p) => (
            <div
              key={p.title}
              className="group relative bg-ink-800 border border-ink-700 hover:border-lime-500/40 rounded-2xl p-7 transition"
            >
              <div className="text-4xl mb-4">{p.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3">{p.title}</h3>
              <p className="text-ink-300 text-sm leading-relaxed mb-5">{p.desc}</p>
              <ul className="space-y-2">
                {p.bullets.map((b) => (
                  <li key={b} className="flex items-start gap-2 text-sm text-ink-200">
                    <svg className="w-4 h-4 mt-0.5 text-lime-500 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd"/>
                    </svg>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
